import {
    Division,
    Offer,
    ConsultationProcess,
} from "../../services/consultation.service";
import { DefinitionIdentifier, UserInfo } from "../../data/product";

export class ProductIndexState {
    constructor(
        public index: IndexSection = new IndexSection(),
        public customOffer: Offer = null,
    ) {}
}

export class IndexSection {
    constructor(
        public name: DefinitionIdentifier = {} as DefinitionIdentifier,
        public application: string = null,
        public category: DefinitionIdentifier = {} as DefinitionIdentifier,
        public line: DefinitionIdentifier = {} as DefinitionIdentifier,
        public enabled = false,
        public canAdd = false,
        public items: IndexSection[] = [],
        public instances: IndexInstance[] = [],
        public visibility: (cp: ConsultationProcess) => boolean = null,
    ) {}
}

export class IndexInstance {
    constructor(
        public name: DefinitionIdentifier,
        public enabled: boolean,
        public canDelete: boolean,
        public isWaiting: boolean,
        public division: Division,
        public productVersion: string,
    ) {}
}
